module.exports = __webpack_public_path__ + "static/MOD2-b9b58a1eb44ae297232eaeb260633e80.jpg";